import Axios from 'axios'
import {programUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_programs (context) {
    Axios.get(programUrls.getAllPrograms).then(function (response) {
      context.commit('GET_ALL_PROGRAMS', response.data)
    })
  },
  get_public_programs (context) {
    Axios.get(programUrls.getPublicProgram).then(function (response) {
      context.commit('GET_ALL_PROGRAMS', response.data)
    })
  },
  get_program_genders (context) {
    Axios.get(programUrls.getProgramGenders).then(function (response) {
      context.commit('GET_GENDERS', response.data)
    })
  },
  get_programs (context, publicId) {
    Axios.get(programUrls.getPrograms + publicId).then(function (response) {
      context.commit('GET_PROGRAMS', response.data)
    })
  },
  get_deleted_programs (context) {
    Axios.get(programUrls.getDeletedProgram).then(function (response) {
      context.commit('GET_DELETED_PROGRAMS', response.data)
    })
  },
  get_program (context, publicId) {
    Axios.get(programUrls.getProgram + publicId).then(function (response) {
      context.commit('GET_PROGRAM', response.data)
    })
  },
  get_program_volunteers (context, publicId) {
    Axios.get(programUrls.getProgramVolunteers + publicId).then(function (response) {
      context.commit('GET_PROGRAM_VOLUNTEERS', response.data)
    })
  },
  post_program (context, data) {
    Axios.post(programUrls.postProgram, data).then(function (response) {
      if(response){
        router.push({
          name: 'VolunteerPrograms'
        })
      }
     
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    
    })
  },
  update_program (context, data) {
    Axios.post(programUrls.editProgram + data.public_id, data).then(function () {
      router.push({
        name: 'VolunteerPrograms'
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      
    })
  },
  delete_program (context, data) {
    Axios.patch(programUrls.deleteProgram + data.public_id, data).then(function () {
      router.push({
        name: 'VolunteerPrograms'
      })
    })
  },
  restoreProgram (context, publicId) {
    Axios.get(programUrls.restoreProgram + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PROGRAMS', response.data)
      router.push({
        name: 'Module.Programs'
      })
    })
  }
}
